import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'equine-ui-nx-donation-receipt',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './donation-receipt.component.html',
  styleUrl: './donation-receipt.component.scss',
})
export class DonationReceiptComponent implements OnInit {

  @Input() type!: 'DIALOG' | 'PRINT';
  @Input() amount!: string;
  @Input() date!: string;

  public loaded = false;


  ngOnInit(): void {
    if (this.type === 'DIALOG') {
      this.loaded = true;
    }

    if (this.type === 'PRINT') {
      this.loaded = true;
    }
  }

}
